import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
	padding: 0 0 40px 40px;
	flex-direction: ${ props => props.view === 'tile' ? 'row' : 'column' };
	flex-wrap: wrap;
	justify-content: flex-start;
`;

const Building = styled(Link)`
	display: flex;
	flex-direction: ${ props => props.browsetype === 'tile' ? 'column' : 'row' };
  background-color: white;
	position: relative;
  width: ${ props => props.browsetype === 'tile' ? 'calc(20vw - 54px)' : '100%' };
	max-width: 90vw;
	min-height: ${ props => props.browsetype === 'tile' ? '300px' : '350px' };
	margin: 0 ${ props => props.browsetype === 'tile' ? '40px' : 'auto' } 40px ${ props => props.browsetype === 'tile' ? '0' : 'auto' };
	padding-left: ${ props => props.browsetype === 'tile' ? '0' : '20vw' };
  cursor: pointer;
  box-shadow: 0 2px 3px 0 rgba(0,0,0,0.2);
  transition: box-shadow 0.3s ease-out, transform 0.3s ease-out;
  transform: translateY(0px);
  text-decoration: none;
  z-index: 1;

  &:hover {
    box-shadow: 0px 10px 50px -10px rgba(60,60,60,0.6);
    transform: translateY(-3px);
	}

	@media (max-width: 2000px) {
		width: ${ props => props.browsetype === 'tile' ? 'calc(25vw - 54px)' : '100%' };
	}

	@media (max-width: 1700px) {
		width: ${ props => props.browsetype === 'tile' ? 'calc(33vw - 55px)' : '100%' };
	}

	@media (max-width: 1200px) {
		width: ${ props => props.browsetype === 'tile' ? 'calc(50vw - 70px)' : '100%' };
		height: ${ props => props.browsetype === 'tile' ? '300px' : 'auto' };
	}
`;

export {
	Container,
	Building,
}
